<template>
    <div class="center">
        <div class="top-txt">项目清单（{{ nNumber }}）</div>
        <div class="userinfo-list">
            <pull-to
                    :top-load-method="downRefresh"
                    :bottom-load-method="upRefresh"
                    :is-bottom-bounce="true"
                    bottom-block-height:0
                    top-block-height:0
            >
                <div
                        class="item"
                        v-for="(item, index) in arrRepor"
                        :key="index"
                        @click="gorepot(item.id)"
                >
                    <div class="proter-title">{{ item.name }}</div>
                    <div class="item-warp address_project_icon">
                        <span>{{ item.city + item.address }}</span>
                    </div>
                    <div class="right_icon">
                        <div class="del_icon" @click.stop="getConf(item.id, index)">
                            <img src="~@/assets/images/ant/info/del_icon.png" alt="" />
                        </div>
                        <div>
                            <img src="~@/assets/images/ant/info/right_icon.png" alt="" />
                        </div>
                    </div>
                </div>
            </pull-to>
        </div>
        <div class="proter-btn" @click="goSubmit">新增项目</div>
        <!-- 确认删除弹窗 -->
        <div class="mask" @touchmove.prevent v-if="bConfirmPopupShow">
            <div class="confirm-popup">
                <div class="popup-close" @click.stop="bConfirmPopupShow = false"></div>
                <div class="confirm-content">
                    <p>删除当前所选方案?</p>
                </div>
                <div class="confirm-btn">
                    <button @click.stop="bConfirmPopupShow = false">取消</button>
                    <button @click.stop="getDel()">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import detail from "@/js/detail.js";
    import PullTo from "vue-pull-to";
    import {Toast} from "mint-ui";

    export default {
        components: {
            Toast,
            PullTo,
        },
        data() {
            return {
                nPage: 0,
                nNumber: 0, //数量
                arrRepor: [], //项目清单列表
                bConfirmPopupShow: false,
                reportId: 0,
                nConfil: 0,
                bLoading: false,
            };
        },
        created() {
            let that = this;
            that.$store.commit("loadSwitch", true);
            $init((res) => {
                Promise.all([that.getReportList()]).then(() => {
                    that.$store.commit("loadSwitch", false);
                });
            });
        },
        methods: {
            getConf(id, index) {
                this.reportId = id;
                this.nConfil = index;
                this.bConfirmPopupShow = true;
            },
            //删除标签
            getDel(id) {
                // console.log(1)
                let that = this;
                detail.getDel({report_id: that.reportId}).then((res) => {
                    //  console.log(res);
                    Toast({
                        message: "删除成功~",
                        duration: 800,
                    });
                    that.arrRepor = [];
                    // that.arrRepor.splice(that.nConfil, 1);
                    // that.nNumber -= 1;
                    that.getReportList();
                    that.bConfirmPopupShow = false;
                });
            },
            //跳转报告详情
            gorepot(id) {
                let that = this;
                this.$store.commit("updateAntReportId", id);
                that.$router.push({path: `/ant/scheme?reportId=${id}`});
            },
            //报告列表
            async getReportList() {
                let that = this;
                let reportData = {
                    wind_uid: that.$route.query.ownerid,
                    page: that.nPage,
                    limit: 10,
                    state: 0,
                };
                await detail.getReportList(reportData).then((res) => {
                    //  console.log(res);
                    let nNumber = res.result.num;
                    let arrRepor = res.result.list;
                    if (arrRepor.length < 10) {
                        that.bLoading = true;
                    }
                    that.nNumber = nNumber;
                    that.arrRepor = that.arrRepor.concat(arrRepor);
                });
            },
            //跳转填写用户信息
            goSubmit() {
                this.$router.push({
                    path: `/antinfo/submit?ownerid=${this.$route.query.ownerid}`,
                });
            },
            //下拉
            downRefresh(loaded) {
                this.nPage = 0;
                this.bLoading = true;
                this.arrRepor = [];
                this.getReportList();
                loaded("done");
            },
            //上拉
            upRefresh(loaded) {
                loaded("done");
                if (this.bLoading) {
                    Toast({
                        message: "没有更多了~",
                        duration: 800,
                    });
                    return false;
                }
                this.nPage += 1;
                this.getReportList();
            },
        },
    };
</script>
<style lang="scss" scoped>
    .mask {
        width: 100%;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 888;
        display: flex;
        justify-content: center;
        align-items: center;

        .confirm-popup {
            width: 652px;
            min-height: 440px;
            border-radius: 20px;
            background-color: rgb(255, 255, 255);
            padding: 40px;
            z-index: 999;
            position: relative;

            .confirm-content {
                p {
                    margin: 100px;
                    text-align: center;
                    font-size: 34px;
                    color: rgb(51, 51, 51);
                    font-weight: bold;
                }
            }

            .confirm-btn {
                display: flex;
                justify-content: center;

                button:nth-child(1) {
                    width: 180px;
                    height: 80px;
                    border-radius: 55px;
                    border-width: 2px;
                    border-color: rgb(51, 51, 51);
                    border-style: solid;
                    color: rgb(51, 51, 51);
                    background-color: #fff;
                    margin-right: 30px;
                    font-size: 30px;
                }

                button:nth-child(2) {
                    width: 180px;
                    height: 80px;
                    background-color: #2c7aec;
                    border-radius: 55px;
                    outline: none;
                    color: #fff;
                    font-size: 30px;
                }
            }
        }

        .popup-close {
            position: absolute;
            top: -15px;
            right: -15px;
            background: url("~@/assets/images/antV2/basicinfo/close.png") top/100% auto no-repeat;
            width: 42px;
            height: 42px;
            flex-shrink: 0;
        }
    }

    @import "index.scss";
</style>
